"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.severity = exports.setLevel = exports.reportError = exports.level = exports.getLevel = exports.category = void 0;
var _constants = require("../../config/constants");
var _string = require("../type-checks/string");
var _ = require(".");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var reportingLevels = {
  ALL: 5,
  INFO: 4,
  WARNING: 3,
  ERROR: 2,
  FATAL: 1,
  OFF: 0
};
var category = exports.category = {
  DATA_MISSING: "data-missing",
  DATA_OLD: "data-old",
  DATA_WRONG: "data-wrong",
  OTHER: "other",
  UI: "ui-broken"
};
var severity = exports.severity = {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high"
};
var reportingLevel = reportingLevels.ALL;
var level = exports.level = function () {
  var levels = {};
  Object.keys(reportingLevels).forEach(function (level) {
    levels[level] = level;
  });
  return levels;
}();
var getLevel = exports.getLevel = function getLevel() {
  return reportingLevel;
};
var setLevel = exports.setLevel = function setLevel(level) {
  if ((0, _string.isStringOfLength)(level) && Object.keys(reportingLevels).includes(level)) {
    reportingLevel = reportingLevels[level];
  }
};
var reportError = exports.reportError = function reportError(level, requestConfig) {
  var alwaysCallback = requestConfig.alwaysCallback,
    beforeCallback = requestConfig.beforeCallback,
    data = requestConfig.data,
    errorCallback = requestConfig.errorCallback,
    failCallback = requestConfig.failCallback,
    headers = requestConfig.headers,
    method = requestConfig.method,
    successCallback = requestConfig.successCallback,
    url = requestConfig.url;
  try {
    if (!(0, _string.isStringOfLength)(level) || !Object.keys(reportingLevels).includes(level)) {
      throw new Error("Invalid reporting level. Must be member of collection: [".concat(Object.keys(reportingLevels).join(", "), "]."));
    }

    // Only execute if overall reportingLevel gte request level;
    if (reportingLevel >= reportingLevels[level]) {
      return (0, _.sendRequest)(url, {
        alwaysCallback: alwaysCallback,
        beforeCallback: beforeCallback,
        data: _objectSpread(_objectSpread({}, data), {}, {
          message: data.message.substring(0, 5000)
        }),
        errorCallback: errorCallback,
        failCallback: failCallback,
        headers: headers,
        method: (0, _string.isStringOfLength)(method) && Object.keys(_constants.REQUEST_METHOD).includes(method.toLowerCase()) ? method.toLowerCase() : _constants.REQUEST_METHOD.POST,
        successCallback: successCallback
      });
    } else {
      console.info("Request to report error at level ".concat(level, " bypassed. Current reporting level: ").concat(reportingLevel));
    }
  } catch (e) {
    console.error(e);
  }
};